module.exports = __webpack_public_path__ + "static/media/IMG_0129.ee158ea0.jpg";